import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

// Providers-Services
import { ApiRestService } from '../../services/shared/api-rest.service';

// import tablas
import { table } from '../../components/shared/tables';

@Injectable({
  providedIn: 'root'
})
export class EstadoService {

  constructor(
    private http: HttpClient,
    private _apiRestService: ApiRestService
  ) { }

  // Consulta cantidad de registros por etapa-estado(para menuBox)
  estado(opt, unidad?) {
    let path;
    if (unidad === true) {
      path = this._apiRestService.APIURL.serv148;
    }
    else {
      path = this._apiRestService.APIURL.serv189;
    }
    return this.http.get(path + `/{"tble":"${table[opt]}"}`
    ).pipe(
      map(
        (res: any) => {
          return res;
        }))
  }

  // Consulta cantidad de registros por etapa-estado Historico-Acumulado(para Grafico de Área)
  estadoHist(tbla, date, cont) {
    return this.http.get(this._apiRestService.APIURL.serv130 + `/{"tble":"${table[tbla]}","date":"${date}","cont":"${cont}"}`
    ).pipe(
      map(
        (res: any) => {
          return res;
        }))
  }
}
